import React from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "@jsq/ds/core";
import * as styles from "../../styles_vanilla.css";
import { hasObjectsWithAmounts, formatMoney, type MoneyType } from "../utils";
import type { GetFundAdminServicesQuery } from "#graphql/supergraphTypes";

type EntityObjectsTableProps = {
  requestType: string;
  entityObjects: NonNullable<
    GetFundAdminServicesQuery["fundAdminServices"]
  >["edges"][number]["node"]["objects"];
};

const EntityObjectsTable = ({ requestType, entityObjects }: EntityObjectsTableProps) => {
  const isEntitiesWithAmounts = hasObjectsWithAmounts(entityObjects);

  const getObjectDetailsAmount = (
    objectDetailsString: string | null | undefined,
  ): MoneyType => {
    const objectDetails = JSON.parse(objectDetailsString ?? "{}") as MoneyType;
    return objectDetails;
  };

  return (
    <Table variant="muted" condensed>
      <TableHeader>
        <TableRow>
          <TableCell>Entity</TableCell>
          {isEntitiesWithAmounts && (
            <TableCell className={styles.amountHeaderCell} rightAligned>
              {requestType} amount
            </TableCell>
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {entityObjects.map((entity) =>
          entity.objectValue.__typename === "AccountObjectType" ? (
            <TableRow key={entity.objectValue.id}>
              <TableCell>{entity.objectValue.name}</TableCell>
              {isEntitiesWithAmounts && (
                <TableCell rightAligned>
                  {formatMoney(getObjectDetailsAmount(entity.objectDetails))}
                </TableCell>
              )}
            </TableRow>
          ) : null,
        )}
      </TableBody>
    </Table>
  );
};

export default EntityObjectsTable;
